import styled from 'styled-components';

const TertiaryText = styled.span`
  color: ${({ theme }) => theme.colors.tertiary};
`;

export default TertiaryText;
